// Native video can load cross-origin MP4/WebM without a fetch-readable HEAD.
// These are container hints, not a guarantee that the codecs are supported.
module.exports = function getContentType(stream) {
    if (!stream || typeof stream.url !== 'string') return Promise.reject(new Error('Invalid stream parameter!'));
    const explicit = stream.behaviorHints?.proxyHeaders?.response?.['content-type'];
    if (typeof explicit === 'string') return Promise.resolve(explicit);
    let pathname;
    try { pathname = new URL(stream.url).pathname.toLowerCase(); }
    catch (_) { return Promise.reject(new Error('Invalid stream URL')); }
    if (/\.mp4$/.test(pathname)) return Promise.resolve('video/mp4');
    if (/\.webm$/.test(pathname)) return Promise.resolve('video/webm');
    // Unknown containers and HLS still need their actual content type.
    return fetch(stream.url, { method: 'HEAD' }).then(response => {
        if (!response.ok) throw new Error('Unable to read stream content type');
        return response.headers.get('content-type');
    });
};
